import { render, staticRenderFns } from "./BuilderStep.vue?vue&type=template&id=18cc171e&scoped=true"
import script from "./BuilderStep.vue?vue&type=script&lang=js"
export * from "./BuilderStep.vue?vue&type=script&lang=js"
import style0 from "./BuilderStep.vue?vue&type=style&index=0&id=18cc171e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cc171e",
  null
  
)

export default component.exports